import c from "../../../utils/constants";

class JobRequestsFilterController {
  constructor($scope, FilterService, EventsService) {
    "ngInject"

    this.filterService = FilterService;
    this.eventsService = EventsService;

    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true)
  }

  $onInit() {
    this.setFilterOptions();

    this.eventsService.listen(c.events.GLOBAL_FILTER_APPLIED, (e, globalFilter) => {
      console.log("Global filter applied::", globalFilter);

      this.setFilterOptions(globalFilter.type);
    })

  }

  setFilterOptions(activeGlobalFilter) {
    this.filterOptions = this.filterService.getJobRequestsFilterOptions(activeGlobalFilter);
    return this.filterOptions;
  }

  onFilterChagne(newval, oldval) {
    this.filterService.generateFilterExpression(this.filterOptions);
    this.applyFilters();
  }

}

export default JobRequestsFilterController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/job-requests-filter/job-requests-filter.controller.js
 **/